import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box, Typography } from '@mui/material';

import type { CMS1500FormData } from '../ClaimCMS1500Form';
import { ClaimTextField } from '../fields';

export const Box09_OtherInsured: React.FC = () => {
  const { control } = useFormContext<CMS1500FormData>();
  return (
    <>
      <Typography variant="caption">{"9. OTHER INSURED'S NAME (Last, First, MI)"}</Typography>
      <Box sx={{ display: "flex", gap: 1, mb: 0.5 }}>
        <Controller
          name="otherInsuredName.lastName"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField
              field={field}
              fieldState={fieldState}
              size="small"
              placeholder="Last"
              sx={{ flex: '1 1 40%' }}
            />
          )}
        />
        <Controller
          name="otherInsuredName.firstName"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField
              field={field}
              fieldState={fieldState}
              size="small"
              placeholder="First"
              sx={{ flex: '1 1 40%' }}
            />
          )}
        />
        <Controller
          name="otherInsuredName.middleInitial"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField
              field={field}
              fieldState={fieldState}
              size="small"
              placeholder="MI"
              inputProps={{ maxLength: 1 }}
              sx={{
                flex: '0 0 80px',
                maxWidth: '80px',
              }}
            />
          )}
        />
      </Box>

      <Typography variant="caption">{"a. OTHER INSURED'S POLICY OR GROUP NUMBER"}</Typography>
      <Controller
        name="otherInsuredPolicyGroup"
        control={control}
        render={({ field, fieldState }) => (
          <ClaimTextField
            field={field}
            fieldState={fieldState}
            size="small"
            fullWidth
            sx={{ mb: 0.5 }}
          />
        )}
      />

      <Typography variant="caption">b. RESERVED FOR NUCC USE</Typography>
      <Controller
        name="otherInsuredReservedNUCC"
        control={control}
        render={({ field, fieldState }) => (
          <ClaimTextField
            field={field}
            fieldState={fieldState}
            size="small"
            fullWidth
            disabled
            sx={{ mb: 0.5 }}
          />
        )}
      />

      <Typography variant="caption">c. RESERVED FOR NUCC USE</Typography>
      <Controller
        name="otherInsuredReservedNUCC2"
        control={control}
        render={({ field, fieldState }) => (
          <ClaimTextField
            field={field}
            fieldState={fieldState}
            size="small"
            fullWidth
            disabled
            sx={{ mb: 0.5 }}
          />
        )}
      />

      <Typography variant="caption">d. INSURANCE PLAN NAME OR PROGRAM NAME</Typography>
      <Controller
        name="otherInsuredPlanName"
        control={control}
        render={({ field, fieldState }) => (
          <ClaimTextField
            field={field}
            fieldState={fieldState}
            size="small"
            fullWidth
          />
        )}
      />
    </>
  );
};